import React, { useState } from "react";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import { showPriceValue } from "../../../../../Helpers/SettingHelper";
import CloseIcon from "@mui/icons-material/Close";
import { Divider } from "@mui/material";

const FilterSheet = (props) => {
  const {
    clearAll,
    filterData,
    handleAmenities,
    state,
    amenities,
    priceVal,
    setPriceVal,
  } = props;
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="filter-main">
      <div className="stay-list-main__content__row__col1__header">
        <div className="stay-list-main__content__row__col1__header__title">
          Filters
        </div>
        <div className="stay-list-main__content__row__col1__header__action">
          <span onClick={() => clearAll()}>Clear all</span>
        </div>
      </div>
      {filterData.amenities?.length > 0 && (
        <>
          <div className="stay-list-main__content__row__col1__filter__content__rowBox1">
            {filterData?.amenities.map((val, index) => (
              <div
                onClick={() => handleAmenities(val)}
                key={index}
                className="stay-list-main__content__row__col1__filter__content__box selected"
              >
                {val} <CloseIcon />
              </div>
            ))}
          </div>
          <Divider />
        </>
      )}
      <div className="stay-list-main__content__row__col1__filter">
        <div className="stay-list-main__content__row__col1__filter__header">
          <div className="stay-list-main__content__row__col1__filter__header__col1">
            <div className="stay-list-main__content__row__col1__filter__header__col1__head">
              Amenities
            </div>
          </div>
          <div className="stay-list-main__content__row__col1__filter__header__col2">
            <span
              className="stay-list-main__content__row__col1__filter__header__col2__more"
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? "Show less" : "Show more"}
            </span>
          </div>
        </div>
        <div className="stay-list-main__content__row__col1__filter__content">
          <div className="stay-list-main__content__row__col1__filter__content__rowBox">
            {amenities
              ?.slice(0, showMore ? amenities?.length : 5)
              .map((val, index) => (
                <div
                  onClick={() => handleAmenities(val)}
                  key={index}
                  className={`stay-list-main__content__row__col1__filter__content__box ${
                    filterData.amenities.includes(val) && "selected"
                  }`}
                >
                  {val}
                  {filterData.amenities.includes(val) && <CloseIcon />}
                </div>
              ))}
          </div>
        </div>
        <Divider />
        <div className="stay-list-main__content__row__col1__filter__header">
          <div className="stay-list-main__content__row__col1__filter__header__col1">
            <div className="stay-list-main__content__row__col1__filter__header__col1__head">
              Price range
            </div>
          </div>
        </div>
        <div className="stay-list-main__content__row__col1__filter__content">
          <div className="stay-list-main__content__row__col1__filter__content__row">
            <div className="stay-list-main__content__row__col1__filter__content__row__col">
              {showPriceValue(
                priceVal[0],
                state.currentCurrency,
                state.currencyRate
              )}
            </div>
            <div className="stay-list-main__content__row__col1__filter__content__row__col">
              {showPriceValue(
                priceVal[1],
                state.currentCurrency,
                state.currencyRate
              )}
            </div>
          </div>
          <RangeSlider
            value={priceVal}
            max={1000}
            onInput={setPriceVal}
            id="range-slider-gradient"
            className="margin-lg"
            step={"any"}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterSheet;
